var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wl-container",domProps:{"innerHTML":_vm._s(_vm.htmlInfo)}})
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }